import { types } from "mobx-state-tree"

export const CreateCourse = types.model({
    name: "",
    abbreviation: "",
    is_active: false,
});
